import { render, staticRenderFns } from "./SalesAnalysisTable.vue?vue&type=template&id=52891348&"
import script from "./SalesAnalysisTable.vue?vue&type=script&lang=js&"
export * from "./SalesAnalysisTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports